import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    brandid: '',
    categoryid: 1,
    startDate: '',
    endDate: '',
    brandData: '',
    xdatetime: [],
    yvalue: [],
    lan: '',
    projectname: '',
    keywordlist: '',
    websitelist: '',
    viewurl: {},
    priceSeries: '',
    priceModel: '',
    totalproducts: 0,
    totalsellers: 0,
    partneremail: ''
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
